<div *ngIf="!read_only" class="form-container">
    <div class="form-box template-email">
        <h3 *ngIf="toSubmit" style="text-align:center">Project survey meeting</h3>
        <p *ngIf="toSubmit">We would like to ask to dedicate a few minutes to provide your feedback on the advice provided by the HSbooster expert</p>
        
        <div class="panel-group" id="accordion_project_survey_meeting">
            <div class="panel panel-default">
              <div class="panel-heading">
                <h5 class="panel-title">
                  <a data-toggle="collapse" data-parent="#accordion" href="#{{ collapsedString }}">{{title}}</a>
                </h5>
              </div>
              <div id="{{ collapsedString }}" class="panel-collapse collapse">
                <div class="panel-body">
                    <div *ngFor="let question of questions">
                        <open-question *ngIf="isOpenQuestion(question)" [type]="'project_survey_meeting'" [question]="getQuestionKey(question)" [editor]="getQuestion(question)" [description]="getQuestionDescription(question)"></open-question>
                        <tick-box *ngIf="!isOpenQuestion(question)" [fields]="question" [type]="'project_survey_meeting'" [description]="getQuestionDescription(question)"></tick-box>
                    </div>
                    <button *ngIf="toSubmit" (click)="confirm()" class="u-btn sop-btn">Save</button>
                </div>
              </div>
            </div>
        
          </div> 

    </div>
</div>

<div *ngIf="read_only" class="form-container">
  <div class="form-box template-email">
      <h3 style="text-align:center">Project survey summary</h3>
      <div class="panel-group" id="accordion_project_survey_meeting">
          <div class="panel panel-default">
            <div class="panel-heading">
              <h5 class="panel-title">
                <a data-toggle="collapse" data-parent="#accordion" href="#{{ collapsedString }}">{{title}}</a>
              </h5>
            </div>
            <div id="{{ collapsedString }}g" class="panel-collapse collapse">
              <div class="panel-body">
                <div class="summary-box">
                  <div class="summary-row" *ngFor="let key of this.getKeys()">
                      <p><strong>{{key}}</strong></p>
                      <p>
                          <i *ngIf="summary[key]===true" class="fa fa-check"></i>
                          <span *ngIf="summary[key]!==true">
                              <div [innerHTML]="summary[key]"></div>
                          </span>
                      </p>
                  </div>
              </div>
              </div>
            </div>
          </div>
      
        </div> 

  </div>
</div>

<svg class="inline-svg">
  <symbol id="check" viewbox="0 0 12 10">
      <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
  </symbol>
</svg>
<style>
  .inline-svg {
      position: absolute;
      width: 0;
      height: 0;
      pointer-events: none;
      user-select: none;
  }
</style>




<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>